import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormArray, FormControl, Form, FormBuilder, Validators } from '@angular/forms';



import {apiUrl} from '../global';

import { ResponseApi } from '../response-api';
import { Break4Service } from '../break4.service';
import { SharedService } from '../shared.service';

function validateEmail(c: FormControl) {
  let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

  return EMAIL_REGEXP.test(c.value) ? null : {
    validateEmail: {
      valid: false
    }
  };
}

@Component({
  selector: 'break22',
  templateUrl: 'break22.component.html',
  styleUrls: ['break22.component.css'],
})
export class Break22Component implements OnInit, AfterViewInit {
  responseApis: ResponseApi[];
  loginAttempt: ResponseApi[];
  error: any;
  backgroundColor: string;
  fadeOutLoader: boolean;
  fadeOutLoaderLogin: boolean;
  logo: any;
  domainList: any;
  userListType: boolean;
  hasUserList: boolean;
  form: any;
  attemptToSubmit: boolean;
  showLoaderLogin: boolean;
  textError: string;
  identifierForServer: string;
  currentQuestion: any;
  baseUrl: any;
  lengthOfQuiz: any;
  orderInQuiz:any;
  organ:any;

  slideIn: boolean;


  genericVal: any;
  nextQuestion: any;

  fadeOut: any;
  fadeInShow: any;


  constructor(private router: Router, private quizService: Break4Service, private route: ActivatedRoute, private sharedService: SharedService) {
    this.attemptToSubmit = true;

    this.fadeOutLoaderLogin = false;
    this.showLoaderLogin = false;

    this.textError = "";
    //this.getUrl;
    this.currentQuestion = false;
    this.slideIn = false;
    this.nextQuestion = false;
  }
  setBackgroundColor(backgroundColor: string):void{
    this.sharedService.setBackgroundColor(backgroundColor);
  }
  getBackgroundColor(){
    return this.sharedService.getVal('backgroundColor');
  }
  getUrl(url: string): void {
    this.quizService
      .getUrl(url)
      .then(responseApi => {
        this.responseApis = responseApi;
        if(this.responseApis['success'] == false){

          this.router.navigate(['page-not-found']);
        }
        else{
          this.organ = this.responseApis[0]['data']['generalDetails'][0]['organ']
        }

      })
      .catch(error => this.error = error);
  }

  postAuthenticate(url: string, username:string): void {
    this.quizService
      .postAuthenticate(url, username)
      .then(responseApi => {
        this.loginAttempt = responseApi;
        console.log(this.loginAttempt);
        var thing = this;
        this.fadeOutLoaderLogin = true;
        console.log(thing.loginAttempt);
        setTimeout(function(){

          thing.fadeOutLoaderLogin = false;
          thing.showLoaderLogin = false;
          thing.textError = thing.loginAttempt['msg'];
          localStorage.setItem('auth', thing.loginAttempt['token']);
          localStorage.setItem('hash', thing.loginAttempt['username']);
          console.log(thing.loginAttempt);
          //this.router.navigate(['page-not-found']);
        }, 1000);

      })
      .catch(error => this.error = error);
  }

  loginUser(){
    if(!this.form.valid){
      this.attemptToSubmit = false;
    }
    else{
      this.attemptToSubmit = true;
      var formValues = this.form.value;
      if(typeof formValues.identifier == 'undefined'){
        this.identifierForServer = formValues.email;
      }
      else{
        this.identifierForServer = formValues.identifier + '@' + formValues.email;
      }
      console.log(formValues);
      this.showLoaderLogin = true;
      this.textError = "";
      this.postAuthenticate(this.route.params['_value'].url, this.identifierForServer);
    }
  }

  markAnswer(elem:any){
    console.log(elem);
  }
  passToNextQuestion(){
    console.log()
    if(this.nextQuestion != false && this.nextQuestion != parseInt(this.route.params['_value'].index)){
      this.router.navigate([this.route.params['_value'].url+'/questionnaire/'+ this.nextQuestion]);
    }
    else{
      console.log('this is the last question!!!!!!');
    }
  }
  updateAnswer(elem:any){
    this.quizService
      .updateAnswer(elem['question_id'], elem['id'], elem['rate'])
      .then(responseApi => {
        this.responseApis = responseApi;
        if(this.responseApis['success'] == false){
          this.router.navigate([this.route.params['_value'].url+'/login']);
        }
        else{
          var m = this;
          setTimeout(function(){
            m.passToNextQuestion();
          }, 1000);
          this.slideIn = true;
          this.getUrl(this.route.params['_value'].url);
        }

      })
      .catch(error => this.error = error);
  }
  fadeOutAndPass(){
    this.fadeInShow = false;
    this.fadeOut = true;
    var thing = this;
    setTimeout(function () {
      thing.router.navigate([thing.route.params['_value'].url+'/questionnaire/'+ thing.route.params['_value'].next+ '/'+thing.route.params['_value'].orientation]);
    }, 1000);
  }
  ngAfterViewInit(){
    this.fadeInShow = true;
  }
  ngOnInit(): void {
    this.backgroundColor = '#ffffff'
    this.fadeOutLoader = false;
    this.logo = false;
    this.baseUrl = apiUrl;
    this.getUrl(this.route.params['_value'].url);


    /*this.genericVal = this.route.params.subscribe(params => {
     const term = params['index'];
     this.getUrl(this.route.params['_value'].url);
     });*/
  }
}



// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/break22/break22.component.ts